module.exports = __webpack_public_path__ + "img/ppgl.8f78986b.png";